<template>
	<div>

		<div>
			<!-- BEGIN panel -->
			<div v-show="!pay_histories.length" class="text-center pt-5">
				<h3> У вас нет операций</h3>
			</div>
			<div v-show="!!pay_histories.length" class="pb-1">
				<h3>История операций:</h3>
			</div>

			<table v-show="!!pay_histories.length" class="table table-hover">
				<thead>
					<tr>
						<th>
							<h5>Дата</h5>
						</th>
						<th>
							<h5>Тип</h5>
						</th>
						<th>
							<h5>Описание</h5>
						</th>
						<th>
							<h5>Сумма</h5>
						</th>
						<th>
							<h5>Баланс</h5>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in pay_histories" v-bind:key="item.id">
						<td>
							{{ item.created_at }}
						</td>
						<td>
							{{ item.type }}
						</td>
						<td>
							{{ item.comment }}
						</td>
						<td v-if="item.balance_delta >= 0">
							<b class="text-green">+{{ item.balance_delta }}</b>
						</td>
						<td v-else>
							<b class="text-red">{{ item.balance_delta }}</b>
						</td>
						<td>
							{{ item.balance }}
						</td>
					</tr>
					<tr v-if="!pay_histories.length">
						<td colspan="4" align="center">У вас нет операций </td>
					</tr>
				</tbody>
			</table>
			<!-- END panel -->
			<Paginator :meta="meta" :fetchData="fetchData" />
		</div>
	</div>
</template>


<script>
import HTTP from "../http";
import { show_error } from "../message";


export default {
	data() {
		return {
			loading: false,
			pay_histories: [],
			curr_page: 1,
			meta: { last_page: 1 }
		};
	},

	mounted() {
		this.fetchData(this.curr_page);
	},
	methods: {
		fetchData(page) {
			this.loading = true;
			this.$insProgress.start();
			HTTP()
				.get("/pay_histories?page=" + page)
				.then((resp) => {
					console.log('resp1', resp)
					this.pay_histories = resp.data.data
					this.meta = resp.data.meta
					this.meta.current_page = !this.meta.current_page ? 1 : this.meta.current_page
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
	}
}
</script>


